//var agp = agp || {};

//agp.fileupload = (function() {

//	function init () {
//		$("#file-upload").on("change", function () {
//			var val = $(this).val();
//			var file = val.split("\\");
//			var fileName = file[file.length - 1];
//			$("#file-name").text(fileName);
//		});
//	}

//	return {
//		init: init
//	};

//}());